import React from "react";

import Render from "@gqlapp/theme";

export default function IncludeNode({
                                      name,
                                      partials = {},
                                      context = {},
                                    }: any) {
  const template =
      partials?.[name];

  if (!template) {
    console.warn(
        `Partial not found: ${name}`
    );
    return null;
  }

  return (
      <Render
          template={template}
          context={context}
      />
  );
}